import { Switch, Route, withRouter } from "react-router-dom";
import logo from "./logo.svg";
import "./App.css";
import LoginPage from "./Pages/LoginPage";
import Dashboard from "./Pages/Dashboard";
import { PrivateRoute } from "./_components/PrivateRoute";
import FeaturePage from "./Pages/FeaturePage";

function App() {
  return (
    <Switch>
      <Route exact path="/" component={LoginPage} />
      <PrivateRoute path="/dashboard" component={Dashboard} />
      <PrivateRoute path="/admin/auctions/:ahco_id" component={FeaturePage} />
    </Switch>
  );
}

export default App;
